/* eslint-disable */

import React, { useEffect, useState } from 'react';
import CardBuySale from '../components/CardBuySale';
import { USER_TYPE } from '../helper/constant/userType';
import MyShop_Seller_JobToDo from './myshop/seller/MyShop_Seller_JobToDo';

function Home(props) {
  const [data_shoporderlist, setData_shoporderlist] = useState([]);
  const [data_shopitemlist, setData_shopitemlist] = useState([]);

  useEffect(() => {
    setData_shoporderlist(props.systemdata_shoporderlist);
  }, [props.systemdata_shoporderlist]);

  useEffect(() => {
    setData_shopitemlist(props.systemdata_shopitemlist);
  }, [props.systemdata_shopitemlist]);

  const user_type = props.permitdata.user_type;
  const isSeller = user_type === USER_TYPE.SELLER || user_type === USER_TYPE.ALL ? true : false;

  const isShopLoggedIn =
    props.permitdata &&
    props.permitdata.role !== 'guest' &&
    props.permitdata.token &&
    props.permitdata.token !== '-';
  const isJobOnlyLoggedIn =
    sessionStorage.getItem('meya-job-loggedin') === 'true' && !isShopLoggedIn;

  return (
    <main id='content' role='main'>
      <div className='container' style={{ marginTop: '48px' }}>
        {isJobOnlyLoggedIn ? (
          <div className='text-center py-5 font-th'>
            <div className='alert p-5 rounded-lg shadow-sm border-0' style={{ background: '#f0fdf4', color: '#15803d' }}>
              <h2 className='font-weight-bold mb-3' style={{ color: '#166534' }}>ยินดีต้อนรับเข้าสู่ มียา.com</h2>
              <p className='lead mb-4' style={{ fontSize: '18px', color: '#166534' }}>
                คุณเข้าสู่ระบบในฐานะสมาชิกหางาน สามารถค้นหาและสมัครงานได้เต็มรูปแบบ
                หากต้องการซื้อขายสินค้า กรุณาเข้าสู่ระบบด้วยบัญชีร้านค้า
              </p>
              <div className='d-flex justify-content-center flex-wrap' style={{ gap: '15px' }}>
                <a href='/jobs' className='btn btn-success text-white font-weight-bold px-4 py-2 rounded-lg' style={{ background: '#10b981', borderColor: '#10b981' }}>
                  ค้นหาตำแหน่งงาน
                </a>
                <a
                  href='/'
                  className='btn btn-outline-success font-weight-bold px-4 py-2 rounded-lg'
                  style={{ color: '#10b981', borderColor: '#10b981' }}
                  onClick={(e) => {
                    e.preventDefault();
                    sessionStorage.removeItem('meya-job-loggedin');
                    sessionStorage.removeItem('meya-job-username');
                    window.location.href = '/';
                  }}
                >
                  เข้าสู่ระบบบัญชีร้านค้า
                </a>
              </div>
            </div>
          </div>
        ) : !isSeller ? (
          <div className='row'>
            <CardBuySale
              imagepath={`${process.env.PUBLIC_URL}/images/welcome-bestbuy.jpg`}
              header='ซื้อสินค้าที่ดีที่สุด'
              keyword='หาง่าย เลือกได้ ขายไว ชุมชนสำหรับร้านยา และคลินิกสำหรับซื้อขายยาและเวชภัณฑ์'
              bottomtext='ซื้อสินค้า'
              pathlink='/marketplace'
              permitdata={props.permitdata}
              mode={'buyer'}
            />
            <CardBuySale
              imagepath={`${process.env.PUBLIC_URL}/images/welcome-salewithus.png`}
              header='ขายสินค้ากับเรา'
              keyword='ติดปีกร้านยาให้เป็นร้านค้าส่ง ง่ายแค่ปายนิ้ว มีของเยอะขายไม่ทัน ปล่อยได้ที่ มียา'
              bottomtext='เริ่มขายสินค้า'
              pathlink='/myshop/seller/jobtodo'
              permitdata={props.permitdata}
              mode={'seller'}
            />
          </div>
        ) : null}

        {isSeller && (
          <MyShop_Seller_JobToDo
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
            data_shoporderlist={data_shoporderlist}
            data_shopitemlist={data_shopitemlist}
            callback_datachanged={(mode, data) => {
              if (props.callback_datachanged) {
                props.callback_datachanged(mode, data);
              }
            }}
          />
        )}
      </div>
    </main>
  );
}

export default Home;
